var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookmarks(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 18",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-870.000000, -877.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(865.000000, 874.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,3 L7,3 C5.9,3 5.01,3.9 5.01,5 L5,21 L12,18 L19,21 L19,5 C19,3.9 18.1,3 17,3 Z M17,18 L12,15.82 L7,18 L7,5 L17,5 L17,18 Z"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTQgMTgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKC04NzAuMDAwMDAwLCAtODc3LjAwMDAwMCkiPgogICAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg4NjUuMDAwMDAwLCA4NzQuMDAwMDAwKSI+CiAgICAgICAgPHBhdGggZD0iTTE3LDMgTDcsMyBDNS45LDMgNS4wMSwzLjkgNS4wMSw1IEw1LDIxIEwxMiwxOCBMMTksMjEgTDE5LDUgQzE5LDMuOSAxOC4xLDMgMTcsMyBaIE0xNywxOCBMMTIsMTUuODIgTDcsMTggTDcsNSBMMTcsNSBMMTcsMTggWiIgPjwvcGF0aD4KICAgICAgPC9nPgogICAgPC9nPgoKPC9zdmc+Cg==";
export { SvgBookmarks as ReactComponent };